import { axios } from "utils";

import { ADMIN_PORK_URL as endpoint } from "consts";

import { PorkFeedType, PorkManureStorage } from "models";

export const getPorkFeedTypesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<PorkFeedType[]> =>
  axios.get(`${endpoint}/pork-feed-types`, { params: { enabled } });

export const getPorkManureStorageAdmin = async (): Promise<PorkManureStorage[]> =>
  axios.get(`${endpoint}/pork-manure-storage-types`, { params: { enabled: true } });
